var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"foodpocket"},[_c('div',{staticClass:"wrapper"},[_c('sidebar'),_c('div',{attrs:{"id":"overlay"},on:{"click":_vm.controlsidebar}}),_c('router-view',{staticStyle:{"flex-shrink":"0","flex-grow":"0"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }